import {
  AspectRatio,
  Box,
  Center,
  Container,
  Heading,
  HStack,
  Stack,
  Text,
  VStack
} from "@chakra-ui/react"

const steps = [
  {
    title: "Investment decisions in minutes",
    description: (
      <>
        Make faster, high-confidence investment decisions with near-instant
        retrofit analysis that replaces weeks of underwriting and enables
        portfolio-wide screening at marginal cost.
      </>
    )
  },
  {
    title: "Heat loss and solar modelling, per home",
    description: (
      <>
        Assess returns and upgrade potential, from heat pumps to solar, using
        our heat loss and solar potential models to map each home's path to
        dramatically reduced energy costs, and with smart tariffs like Octopus
        Tenant Power, potential returns from surplus generation.
      </>
    )
  },
  {
    title: "Portfolio insights & fund matching",
    description: (
      <>
        Get a clear view of your capital deployment, projected returns, retrofit
        costs, available funding and carbon impact, so you can make faster, more
        informed investment decisions.
      </>
    )
  }
]

const HowItWorks: React.FC = () => (
  <Container maxW="container.xl" py={20}>
    <Center>
      <Heading
        as="h2"
        size="4xl"
        mb={16}
        color="brand.700"
        style={{ textWrap: "balance" } as React.CSSProperties}
      >
        How It Works
      </Heading>
    </Center>
    <Stack direction={["column", "row"]} gap={6} align="center">
      <Box w={["100%", "60%"]}>
        <Box border="12px solid" borderColor="brand.700" borderRadius="xl">
          <AspectRatio ratio={16 / 9}>
            <video
              autoPlay
              loop
              muted
              controls
              width="720"
              preload="metadata"
              poster="/images/demo.png"
            >
              <source src="/images/demo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </AspectRatio>
        </Box>
      </Box>
      <VStack w={["100%", "40%"]} gap={8} align="stretch" px={8}>
        {steps.map((step, index) => (
          <HStack gap={6} align="start" w="full" key={index}>
            <Box>
              <Heading as="h3" size="2xl" color="brand.600" mb={1}>
                {step.title}
              </Heading>
              <Text color="gray.600">{step.description}</Text>
            </Box>
          </HStack>
        ))}
      </VStack>
    </Stack>
  </Container>
)

export default HowItWorks
